import { AttributeNodeDetails, NodeDetails, RelationNodeDetails, RelationDetails, AbstractNodeDetails, AbstractRelationDetails } from './renderers'
import {
  NODE
  RELATION
  RELATION_NODE
  RELATION_VIEW
  ATTRIBUTES
  VIEWTYPE
  ATTRIBUTE_NODE
} from 'Types'

export configureItemRenderer = (type, subType, viewType) ->
  if type in [NODE, ATTRIBUTES] and viewType isnt VIEWTYPE.ABSTRACT
    if subType is ATTRIBUTE_NODE
      AttributeNodeDetails
    else if subType is RELATION_NODE
      RelationNodeDetails
    else
      NodeDetails
  else if type is RELATION and viewType isnt VIEWTYPE.ABSTRACT
    if subType is ATTRIBUTE_NODE
      AttributeNodeDetails
    else
      RelationDetails
  else if type in [NODE, ATTRIBUTES] and viewType is VIEWTYPE.ABSTRACT
    AbstractNodeDetails
  else if type is RELATION and viewType is VIEWTYPE.ABSTRACT
    AbstractRelationDetails
  else
    -> <div />
